<main class="main">
    <section class="introduction">
        <div class="flex">
            <div class="description">
                <h1 class="title static-page-title" [innerHTML]="'App.ColorectalPage.IntroductionSection.Title' | translate"></h1>
                <p class="text static-page-paragraph-text" translate>App.ColorectalPage.IntroductionSection.Text</p>
            </div>
            <img src="assets/images/colorectal_main.png" class="image"
                 [alt]="'App.ImageAlts.SplashPageImg' | translate"
                 width="390" height="385">
        </div>
         <div class="Intro-image">
            <div class="Intro-imageSpan" role="img" aria-label="Pan Can Homepage Image">
                <span class="Intro-imageInner"></span>
            </div>
        </div>
        <div class="logos">
            <img src="assets/images/logo-broad.svg"
                 [alt]="'App.HomePage.IntroductionSection.BroadAlt' | translate"
                 width="124" height="32">
            <img src="assets/images/dana-farber-logo.png"
                 [alt]="'App.HomePage.IntroductionSection.DanaFarberAlt' | translate"
                 width="124" height="32">
        </div>
    </section>
    <section class="tl-section-wrapper" id="tl-section-wrapper">
            <section class="main-timeline-title">
                <div class="tl-container container py-5">
                    <div class="row">
                        <section
                            class=" col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1 NoPadding">
                            <h2 translate>App.ColorectalPage.TimelineSection.Title</h2>
                        </section>
                    </div>
                    <div class="main-timeline">
                        <div class="timeline left">
                            <div class="card WrapperTL">
                                <div class="card-body p-4 WrapperTL">
                                    <h3 translate>App.ColorectalPage.TimelineSection.TimelineTitle1</h3>
                                    <div [innerHTML]="'App.ColorectalPage.TimelineSection.TimelineBody1' | translate"
                                        class="timeline-body-text"></div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline right">
                            <div class="card WrapperTL">
                                <div class="card-body p-4 WrapperTL">
                                    <h3 translate>App.ColorectalPage.TimelineSection.TimelineTitle2</h3>
                                    <div [innerHTML]="'App.ColorectalPage.TimelineSection.TimelineBody2' | translate"
                                        class="timeline-body-text"></div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline left">
                            <div class="card WrapperTL">
                                <div class="card-body p-4 WrapperTL">
                                    <h3 translate>App.ColorectalPage.TimelineSection.TimelineTitle3</h3>
                                    <div [innerHTML]="'App.ColorectalPage.TimelineSection.TimelineBody3' | translate"
                                        class="timeline-body-text"></div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline right">
                            <div class="card WrapperTL">
                                <div class="card-body p-4 WrapperTL">
                                    <h3 translate>App.ColorectalPage.TimelineSection.TimelineTitle4</h3>
                                    <div [innerHTML]="'App.ColorectalPage.TimelineSection.TimelineBody4' | translate"
                                        class="timeline-body-text"></div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline left">
                            <div class="card WrapperTL">
                                <div class="card-body p-4 WrapperTL">
                                    <h3 translate>App.ColorectalPage.TimelineSection.TimelineTitle5</h3>
                                    <div [innerHTML]="'App.ColorectalPage.TimelineSection.TimelineBody5' | translate"
                                        class="timeline-body-text"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        
    </section>
</main>
<app-splash-page-footer
    text='App.ColorectalPage.Footer.Text'
    [phone]="phone"
    [email]="email">
</app-splash-page-footer>
